import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { NppPermessiService } from 'app/main/pages/npp/services/npp-permessi.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-manuale',
  standalone: true,
  imports: [CommonModule, RouterModule, MatButtonModule, MatIconModule],
  templateUrl: './manuale.component.html',
  styleUrls: ['./manuale.component.scss']
})
export class ManualeComponent implements OnInit, OnDestroy {
  showManualButton = false;
  manualOpen = false;
  manualPage = '';

  private subscriptions = new Subscription();
  private manualPermission = false;

  constructor(
    private router: Router,
    private nppPermessiService: NppPermessiService
  ) {}

  ngOnInit(): void {
    this.updatePage(this.router.url);

    this.subscriptions.add(
      this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
        this.manualOpen = false;
        this.updatePage(event.urlAfterRedirects);
      })
    );

    this.subscriptions.add(
      this.nppPermessiService.getPermessi().subscribe(permessi => {
        this.manualPermission = !!(permessi && permessi.menu && permessi.menu.visualizza_manuale === true);
        this.updatePage(this.router.url);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  toggleManual(): void {
    this.manualOpen = !this.manualOpen;
  }

  closeManual(): void {
    this.manualOpen = false;
  }

  private updatePage(url: string): void {
    const pageUrl = url.split('?')[0].replace(/\/+$/, '') || '/dls';
    this.showManualButton = this.manualPermission && pageUrl.startsWith('/dls');
    this.manualPage = this.getManualPage(pageUrl);
  }

  private getManualPage(url: string): string {
    if (url === '/dls') return 'home';
    if (url === '/dls/compilazioni') return 'compilazioni';
    if (url.indexOf('/dls/compilazioni/') === 0) return 'compilazioni-dettaglio';
    if (url === '/dls/abbonamento') return 'abbonamento';
    if (url === '/dls/storico-fatture') return 'storico-fatture';
    if (url === '/dls/contatta-consulente') return 'contatta-consulente';
    if (url.indexOf('/dls/contatta-consulente/') === 0) return 'contatta-consulente-dettaglio';
    if (url === '/dls/contenuti') return 'contenuti';
    if (url.indexOf('/dls/contenuti/') === 0) return 'contenuto-dettaglio';
    if (url === '/dls/contenuto-privacy') return 'contenuto-privacy';
    if (url === '/dls/contenuto-privacy/upsert') return 'contenuto-privacy-upsert';
    if (url.indexOf('/dls/contenuto-privacy/upsert/') === 0) return 'contenuto-privacy-upsert-modifica';
    if (url === '/dls/webinar') return 'webinar';
    if (url === '/dls/community' || url === '/dls/community/') return 'community';
    if (url === '/dls/community/q') return 'community-ricerca';
    if (url.split('/').length >= 6) return 'community-discussione';
    if (url.indexOf('/dls/community/') === 0) return 'community-categoria';

    return '';
  }
}
